(() => {
  class CarLyncProductOffers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.bundleOptions = Array.from(this.querySelectorAll('[data-cl-bundle]'));
      this.status = this.querySelector('[data-cl-bundle-status]');

      this.bundleOptions.forEach((option) => {
        // Clicking an already-selected offer must also restore its quantity.
        option.addEventListener('click', () => this.selectBundle(option));
      });

      const details = this.closest('.product-details');
      details?.addEventListener('quantity-selector:update', (event) => {
        if (event.target !== this.quantitySelector || this.dataset.bundleDiscountsActive !== 'true') return;

        const quantity = Number(this.quantitySelector.getValue());
        this.bundleOptions.forEach((option) => {
          option.checked = !option.disabled && Number(option.dataset.quantity) === quantity;
        });

        if (this.status) {
          this.status.textContent = quantity === 3
            ? '3 adapters selected'
            : `${quantity} ${quantity === 1 ? 'adapter' : 'adapters'} selected — select the offer for 3 adapters`;
        }
      });
      details?.addEventListener('change', (event) => {
        if (event.target instanceof HTMLElement && event.target.closest('variant-picker')) {
          window.setTimeout(() => this.syncAvailability(), 500);
        }
      });

      const selectedOption = this.querySelector('[data-cl-bundle]:checked');
      if (selectedOption && !selectedOption.disabled) {
        customElements.whenDefined('quantity-selector-component').then(() => this.selectBundle(selectedOption));
      }
    }

    get quantitySelector() {
      return this.closest('.product-details')?.querySelector('quantity-selector-component') || null;
    }

    selectBundle(option) {
      if (!(option instanceof HTMLInputElement) || option.disabled) return;

      const quantity = Number(option.dataset.quantity || 1);
      const selector = this.quantitySelector;
      if (!selector) return;

      const maximum = selector.getEffectiveMax?.();
      if (maximum !== null && maximum !== undefined && quantity > maximum) {
        option.checked = false;
        const currentQuantity = Number(selector.getValue?.() || 1);
        const fallback = this.bundleOptions.find(
          (candidate) => !candidate.disabled && Number(candidate.dataset.quantity) === currentQuantity
        );
        if (fallback) fallback.checked = true;
        if (this.status) this.status.textContent = `Only ${maximum} available to add right now`;
        return;
      }

      selector.setValue?.(String(quantity));
      selector.onQuantityChange?.();
      selector.updateButtonStates?.();

      if (this.status) {
        this.status.textContent = quantity === 1 ? '1 adapter selected' : `${quantity} adapters selected`;
      }
    }

    syncAvailability() {
      const productForm = this.closest('.product-details')?.querySelector('product-form-component');
      const variantId = productForm?.querySelector('input[name="id"]')?.value;
      const variantsNode = this.querySelector('[data-cl-variants]');
      if (!variantId || !variantsNode?.textContent) return;

      let variants;
      try {
        variants = JSON.parse(variantsNode.textContent);
      } catch (_error) {
        return;
      }

      const variant = variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      const discountsActive = this.dataset.bundleDiscountsActive === 'true';
      this.bundleOptions.forEach((option) => {
        const quantity = Number(option.dataset.quantity || 1);
        option.disabled = !variant.available || (quantity > 1 && !discountsActive);
      });

      if (!variant.available && this.status) this.status.textContent = 'Selected option is currently sold out';
    }
  }

  if (!customElements.get('carlync-product-offers')) {
    customElements.define('carlync-product-offers', CarLyncProductOffers);
  }
})();
